<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="审批编码：" prop="num">
            <el-input v-model="query.num" placeholder="请输入审批编码" size="small" clearable />
          </el-form-item>
          <el-form-item label="申请人信息：" prop="nameOrPhoYw">
            <el-input v-model="query.nameOrPhoYw" placeholder="请输入姓名/手机号" size="small" clearable />
          </el-form-item>
          <el-form-item label="客户信息：" prop="nameOrPho">
            <!-- <el-input v-model="query.nameOrPho" placeholder="请输入姓名/手机号" size="small" clearable /> -->
            <el-input v-model="query.nameOrPho" placeholder="请输入姓名/手机号" size="small" clearable />
          </el-form-item>
          <!-- <el-form-item label="申请人身份：">
            <el-select v-model="query.deptId" placeholder="请选择" clearable size="small">
              <el-option :label="item.name" :value="item.level" v-for="item in sectionList" :key="item.id"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="申请类型：">
            <el-select v-model="query.registrationType" placeholder="请选择" clearable size="small">
              <el-option label="普通人员升级研修班" :value="1"></el-option>
              <el-option label="普通人员升级体验班" :value="2"></el-option>
              <el-option label="体验班升级研修班" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="支付单号：" prop="payNum">
            <el-input v-model="query.payNum" placeholder="请输入支付单号" size="small" clearable />
          </el-form-item>
          <el-form-item label="时间筛选：">
            <el-select v-model="query.timeType" placeholder="请选择" clearable size="small">
              <el-option label="提交时间" :value="0"></el-option>
              <el-option label="同意时间" :value="1"></el-option>
              <el-option label="驳回时间" :value="2"></el-option>
            </el-select>
            <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>
          <el-form-item class="fr">
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <el-tabs v-model="activeName" @tab-click="doQueryList({pageNo:1})">
          <el-tab-pane label="待审核" name="0"></el-tab-pane>
          <el-tab-pane label="同意申请" name="1"></el-tab-pane>
          <el-tab-pane label="驳回申请" name="2"></el-tab-pane>
        </el-tabs>
        <div class="btn-box">
          <el-button type="primary" plain size="mini" @click="handleAddPayWK">新增</el-button>
          <el-button type="primary" plain size="mini" @click="handleDownload">导出</el-button>
        </div>
      </div>
      <el-table v-loading="listLoading" :data="list" :key="activeName">
        <el-table-column label="审批编号" prop="num" align="center" fixed width="140">
          <template slot-scope="{row}">
            <div @click="handleShowDetail(row.id)">
              <el-link type="primary">{{row.num}}</el-link>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="申请人信息" prop="userPho" align="" fixed width="200">
          <template slot-scope="{row}">
            <div>{{row.applyName}}</div>
            <div>{{row.applyPho}}</div>
          </template>
        </el-table-column>
        <el-table-column label="提交来源" prop="dataSource" align="center" width="120">
          <template slot-scope="{row}">
            <div>{{ dataSourceArr[row.dataSource] }}</div>
          </template>
        </el-table-column>
        <el-table-column label="申请人身份" prop="deptName" align="center" width="120">
          <template slot-scope="{row}">
            <div>{{row.applyLevelName}}</div>
          </template>
        </el-table-column>
        <el-table-column label="申请类型" prop="registrationType" align="center" width="110">
          <template slot-scope="{row}">
            <div>{{getApplyType(row)}}</div>
          </template>
        </el-table-column>
        <el-table-column label="申请内容" prop="userPho" align="" width="240">
          <template slot-scope="{row}">
            <div v-if="row.customerPO">{{row.customerPO.name}}({{row.customerPO.levelName}}) <span>{{row.customerPO.pho}}</span></div>
          </template>
        </el-table-column>
        <el-table-column label="报名费用" prop="fee" align="center" />
        <el-table-column label="赠送金额" prop="upgradeGiftAmount" align="center">
          <template slot-scope="{row}">
            <span v-if="row.upgradeGiftAmount > 0">{{ row.upgradeGiftAmount }}</span>
          </template>
        </el-table-column>
        <el-table-column label="付款凭证" prop="deptName" align="center" width="200">
          <template slot-scope="{row}">
            <span class="imgs" v-if="row.payPOList && row.payPOList.length">
              <el-image style="width: 50px; height: 50px;margin-right:5px" :src="item.payImg" :preview-src-list="[item.payImg]" v-for="item in row.payPOList" :key="item.id"></el-image>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="支付单号" prop="" align="center">
          <template slot-scope="{row}">
            <span class="imgs" v-if="row.payPOList && row.payPOList.length">
              {{row.payPOList.map(i=>(i.payNum)).filter(i=>i).join(',')}}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="附件" prop="" align="center" width="200">
          <template slot-scope="{row}">
            <span class="imgs" v-if="row.applyVoucher">
              <el-image style="width: 50px; height: 50px;margin-right:5px" :src="item" :preview-src-list="[item]" v-for="(item,index) in row.applyVoucher.split(',')" :key="index"></el-image>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="提交时间" prop="createdTime" sortable align="center" width="200" />
        <el-table-column label="同意时间" prop="auditTime" sortable align="center" width="200" v-if="activeName=='1'" />
        <el-table-column label="驳回时间" prop="auditTime" sortable align="center" width="200" v-if="activeName=='2'" />
        <el-table-column label="驳回原因" prop="reasonForRejection" align="center" v-if="activeName=='2'" />
        <el-table-column label="操作人" prop="" align="center" v-if="activeName!='0'">
          <template slot-scope="{row}">
            <div>{{row.realName}}</div>
            <!-- <div>{{row.realName}}</div> -->
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right" width="160" v-if="activeName=='0' || activeName=='1'">
          <template slot-scope="{row}">
            <!-- <el-button type="text" @click="handleCreate(1,row)" v-if="activeName=='0'" v-hasPermi="['finance:proofAudit:examine']">同意</el-button>
            <el-button type="text" @click="handleUpdate(row)" v-if="activeName=='0'" v-hasPermi="['finance:proofAudit:examine']">驳回</el-button> -->
            <el-button type="text" @click="handleLog(row)" v-if="activeName=='1'" >日志记录</el-button>
          </template>
        </el-table-column>
      </el-table>

      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
    <!-- 新建表单 -->
    <city-add ref="cityAdd" @created="doQueryList({})" :sectionList="configList" />
    <add-fee-vue ref="addFeeVue" @created="doQueryList({})" :sectionList="configList" />
  </div>
</template>

<script>
import cityCompanyApi from '@/api/sys/cityCompany'
import sysDeptApi from '@/api/sys/sysDept'
import Pagination from '@/components/Pagination'
import customerRegistrationApi from '@/api/cust/customerRegistration'
import cityAdd from './add'
import sysDataconstantApi from '@/api/config/sysDataconstant'
import addFeeVue from './addFee.vue'
// import customerLevelApi from '@/api/sys/customerLevel'
export default {
  components: {
    Pagination,
    cityAdd,
    addFeeVue
    // businessQuit,
    // businessAdjust,
    // areaRemove
  },
  data() {
    return {
      popType: null,
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
        // isInternal:1
      },
      sectionList: [],
      dateTime: null,
      activeName: '0',
      configList: [],
      dataSourceArr: ['', 'app业务员添加', '管理员添加', 'app客户报名', '管理员导入']
    }
  },
  created() {
    this.doQueryList({
      pageNo: 1
    })
    this.getConfig()
    this.sectionList = JSON.parse(localStorage.getItem('levelList'))
    // this.getOption()
  },
  methods: {
    handleAddPayWK() {
      this.$refs.addFeeVue.handleCreate()
    },
    setClevel(val) {
      let obj = this.sectionList.find(item => item.level == val)
      console.log('obj: ', obj);
      if (obj) {
        return obj.name
      } else {
        return val
      }
    },
    getApplyType(row) {
      if (!row) return '-'
      if (row.registrationType === 1) return '普通人员升级研修班'
      if (row.registrationType === 2) return '普通人员升级体验班'
      if (row.registrationType === 3) return '体验班升级研修班'
      //10|体降普，20|研降普
      if (row.registrationType === 10) return '体验班降级为普通人员'
      if (row.registrationType === 20) return '研修班降级为普通人员'
      if (row.registrationType === 30) return '研修班降级为体验班'
      return '-'
    },
    handleUpdate(row) {
      this.$prompt(
        '是否确认驳回申请',
        '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPlaceholder: '请输入驳回原因',
      }).then(({
        value
      }) => {
        customerRegistrationApi.agreeOrReject({ reasonForRejection: value, state: 2, id: row.id })
      })
        .then(() => {
          this.$message.success('提交成功！')
          setTimeout(() => {
            this.doQueryList({
              pageNo: 1
            })
          }, 1000)
        })
    },
    handleFilter() {
      this.query = {
        pageNo: 1,
        pageSize: 10,
        isInternal: 1
      }
      this.dateTime = []
      this.doQueryList({
        pageNo: 1
      })
    },
    // 获取部门
    getOption() {
      sysDeptApi.findOptions().then(({
        data
      }) => {
        this.sectionList = data
      })
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({
        pageNo: 1
      })
    },
    /**
     * 执行列表查询
     */
    doQueryList({
      pageNo,
      pageSize
    }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.query.state = this.activeName * 1
      let query = {
        ...this.query,
      }
      if (this.query.timeType == 2) {
        query.timeType = 1
      }
      if (this.dateTime && this.dateTime.length) {
        query.startTime = this.dateTime[0]
        query.endTime = this.dateTime[1]
      }
      this.listLoading = true
      return customerRegistrationApi.fetchList(query)
        .then(({
          data
        }) => {
          console.log("data: ", data);
          this.list = data.list
          this.total = data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    // 获取系统配置
    getConfig() {
      sysDataconstantApi.fetchBatchCode({
        code: 'lineUpMoneyBankType'
      }).then(({
        data
      }) => {
        this.configList = data.list[0].content ? JSON.parse(data.list[0].content) : []
        // console.log("配置: ", this.configList);
      })
    },
    /**
     * 打开新建、编辑表单
     */
    handleCreate(type, row) {
      this.$refs.cityAdd.handleCreate(row)
    },
    //查看信息
    handleShowDetail(id) {
      this.$emit('handleShow', id, 2)
    },
    handleDownload() {
      this.$router.push("/export/list?code=registrationExport")
    },
     /**
     * 日志记录
     */
     handleLog(row) {
      this.$router.push("/log/log?type=130&id=" + row.id)
    }
  }
}
</script>
